/**
 * From: https://stackoverflow.com/a/5624139/710630
 *
 * @param {string} hex
 * @return {{r: number, b: number, g: number}}
 */
function hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    } : { r: 0, g: 0, b: 0 };
}

/**
 * @param {object} vars
 *
 * @return {string}
 */
function objectToCssVarsString(vars) {
    let str = ':root { ';
    Object.keys(vars).forEach((key) => {
        str += `--${key}: ${vars[key]};\n`;
    });
    str += ' }';

    return str;
}

/**
 * From: https://stackoverflow.com/a/13532993/710630
 *
 * @param {string} color
 * @param {number} percent
 * @return {string}
 */
function shadeColor(color, percent) {
    let R = parseInt(color.substring(1, 3), 16);
    let G = parseInt(color.substring(3, 5), 16);
    let B = parseInt(color.substring(5, 7), 16);

    R = parseInt(R * ((100 + percent) / 100));
    G = parseInt(G * ((100 + percent) / 100));
    B = parseInt(B * ((100 + percent) / 100));

    R = (R < 255) ? R : 255;
    G = (G < 255) ? G : 255;
    B = (B < 255) ? B : 255;

    R = Math.round(R / 10) * 10;
    G = Math.round(G / 10) * 10;
    B = Math.round(B / 10) * 10;

    let RR = ((R.toString(16).length === 1) ? '0' + R.toString(16) : R.toString(16));
    let GG = ((G.toString(16).length === 1) ? '0' + G.toString(16) : G.toString(16));
    let BB = ((B.toString(16).length === 1) ? '0' + B.toString(16) : B.toString(16));

    return '#' + RR + GG + BB;
}

module.exports = {
    hexToRgb,
    objectToCssVarsString,
    shadeColor,
};
